import { WizActionObj } from './../../../obj/navigation/wiz-action.obj';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { WizButton } from './../../controls/button/wiz-button/wiz-button';
import { WizEvent } from '../../../events/wiz-event';
import { WizEventManager } from '../../../events/wiz-event.manager';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, Renderer2 } from "@angular/core";
/**
 * Bouton tab
 */
@Component({
  selector: 'wiz-tab-button',
  templateUrl: './wiz-tab-button.html',
  styleUrls: ['./wiz-tab-button.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush // pas de listeneur permanent
})
export class WizTabButton extends WizButton {

  public fullDesc: string = ''; // description pour le tooltip

  // masquer le delete (mode colonne)
  @Input() noDelete: boolean = false;

  public get showDelete(): boolean {
    return !this.noDelete && this.getData()?.showDelete;
  }

  // masquer le rendu linéraire
  @Input() noLinear: boolean = false;

  public get color(): string {
    return 'inherit';
    // return this.getData().lineColor || 'inherit';
  }

  public get lineBackground(): string {
    const actionObj = this.getData();
    if (!!actionObj && !!actionObj.lineColor){//  && !this.noLinear) {
      
      if(this.noLinear) {
        return 'linear-gradient(225deg, ' + actionObj.lineColor + ' 0%, #ffffff00 5%, #ffffff00 100%)';
      } else {
        // return actionObj.lineColor;
        return 'linear-gradient(to bottom, #ffffff00 0%, #ffffff00 80%,' + actionObj.lineColor + ' 100%)';
      }

    } else {
      return '#ffffff00';
    }
  }

  /**
   * Référence à l'objet d'action définissant les propriétés du bouton (label, style...)
   */
  @Input()
  public set actionObj(pActionObj: WizActionObj) {
    this.setData(pActionObj);
    //console.log('WizActionObj', this.data);
    const actionObj = this.data; // gestion du tooltip
    // if (!!actionObj && !!actionObj.moreArgs && 'description' in actionObj.moreArgs) {
    //   this.fullDesc = actionObj.moreArgs['description'];
    // } else {
    this.fullDesc = actionObj.description || actionObj.label;
    // }

    this.cdref.markForCheck();
  }

  public get actionObj(): WizActionObj {
    return this.getData();
  }

  /** Constructor with translation engine
   * @param cdref: ChangeDetectorRef
   * @param elementRef: ref au dom (point d'entrée)
   * @param renderer : rendu
   */
  constructor(protected cdref: ChangeDetectorRef,
              public elementRef: ElementRef,
              public  renderer: Renderer2
  ) {
    super(cdref, elementRef, renderer);
    this.setSelectedClassName('selected-tab-class');
  }

  /**
   * Handler de l'icône de suppression
   * @param event clic
   */
  public onClear(event: MouseEvent) {
    // stopper l'event, pour ne pas appeler la sélection
    event.stopImmediatePropagation();
    event.preventDefault();
    const wizEvent: WizEvent = new WizEvent(WIZ_EVENT_TYPE.DELETE, this, this.data);
    WizEventManager.dispatchEvent(this.elementRef, wizEvent);
  }
}
